import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';

import Banner from '../Banner';

const PromoBanner = ({ bannerText, bannerLink }) => (
  <Banner
    text={bannerText}
    link={bannerLink}
  />
);

PromoBanner.propTypes = {
  bannerText: PropTypes.string,
  bannerLink: PropTypes.string
};

export const query = graphql`
  fragment PromoBannerFragment on ContentfulPromoBanner {
    id
    __typename
    bannerText
    bannerLink
    personalizations {
      ...PersonalizationFragment
    }
  }
`;

export default PromoBanner;
